import type { I18nLocale } from "@/modules/i18n/types"

import { createContext, useContext } from "react"

export type PageTranslations = Partial<Record<I18nLocale, string>>

type FoLayoutContextType = {
  allowedLocales: PageTranslations
  host: string
  isHeaderNeeded: () => boolean
}

const FoLayoutContext = createContext<FoLayoutContextType>({
  allowedLocales: {},
  host: "",
  isHeaderNeeded: () => false,
})

const useFoLayoutContext = (): FoLayoutContextType => useContext(FoLayoutContext)

export { FoLayoutContext, useFoLayoutContext }
